import React, { useContext } from 'react';
import PlayerInsightButton from '../../PlayerInsightButton/PlayerInsightButton';
import { LocalizationContext } from '../../../context/localizationContext';
import Styles from './HowInfo.module.scss';
import checkmark from '../../../assets/images/icons/checkmark.svg';

const HowInfo = (props) => {
  const { toggleInstructions } = props;
  const localization = useContext(LocalizationContext);
  const { tileText } = localization;
  const { description } = tileText;
  const { howToLinkRequirements } = description;

  return (
    <div className={Styles.howInfo}>
      {howToLinkRequirements.map((item, i) => {
        return (
          <div className={Styles.instructions} key={i}>
            <div className={Styles.listHeader}>{item.header}</div>
            {item.items.map((listItem, j) => {
              return (
                <li className={Styles.listItem} key={j}>
                  <div>
                    <img src={checkmark} alt='check' />
                  </div>
                  <div dangerouslySetInnerHTML={{
                    __html: listItem,
                  }}></div>
                </li>
              );
            })}
          </div>
        );
      })}
      <PlayerInsightButton
        label={description.howToConfirmBtnText}
        onClick={() => toggleInstructions(false)}
      />
    </div>
  );
};

export default HowInfo;
